function goToSection(event) {
  const contentPaddingTop = 111;
  let hash = '';

  if (event.type === 'load' && window.location.hash !== '') {
    ({ hash } = window.location);
  } else if (event.type === 'click') {
    hash = event.currentTarget.getAttribute('href');
  }

  if (hash !== '') {
    const destElement = event.currentTarget.dataset.external ? document.querySelector(hash)
      : event.currentTarget;
    const element = window.location.hash === ''
      ? destElement
      : document.querySelector(`.js-anchors[href="${hash}"]`);
    if (element) {
      const y = window.scrollY + element.getBoundingClientRect().top - contentPaddingTop;
      window.scrollTo(0, y);
    }
  }
}

function init() {
  document.querySelectorAll('.js-anchors').forEach((anchor) => {
    anchor.addEventListener('click', goToSection);
  });

  if (window.location.hash !== '') {
    window.addEventListener('load', goToSection);
  }
}

export default init;
